import { Skeleton } from "@mantine/core";
import styles from "./styles/Category.module.css";

const placeholders = (count: number) => Array.from({ length: count }, (_, i) => i);

/**
 * Loading state that mirrors CategoryHero, FreshEpisodes and StartHere so the
 * page does not jump when the real content arrives.
 */
export const CategorySkeleton = () => {
    return (
        <div aria-busy="true" aria-label="Laddar kategori">
            <section className={styles.hero}>
                <div className={styles.heroCopy}>
                    <Skeleton height={14} mb="sm" width={160} />
                    <Skeleton height={64} mb="md" width="60%" />
                    <Skeleton height={14} mb={8} width="90%" />
                    <Skeleton height={14} width="70%" />
                    <div className={styles.skeletonActions}>
                        <Skeleton height={36} radius="md" width={210} />
                        <Skeleton height={36} radius="md" width={170} />
                    </div>
                </div>
                <div className={styles.featured}>
                    <Skeleton className={styles.featuredImage} radius={0} />
                    <div className={styles.featuredBody}>
                        <Skeleton height={20} width={72} />
                        <Skeleton height={24} width="80%" />
                        <Skeleton height={14} width="50%" />
                        <Skeleton height={44} mt="xs" radius="md" width={110} />
                    </div>
                </div>
                <div className={styles.chips}>
                    <Skeleton height={14} width={140} />
                    <div className={styles.skeletonChips}>
                        {placeholders(6).map((i) => (
                            <Skeleton height={34} key={i} radius="xl" width={90 + (i % 3) * 24} />
                        ))}
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <Skeleton height={32} mb="md" width={180} />
                <div className={styles.freshRow}>
                    {placeholders(6).map((i) => (
                        <div className={styles.freshCard} key={i}>
                            <Skeleton className={styles.skeletonSquare} mb={6} radius="md" />
                            <Skeleton height={14} width="95%" />
                            <Skeleton height={14} width="60%" />
                            <Skeleton height={12} width="40%" />
                        </div>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <Skeleton height={32} mb="md" width={210} />
                <div className={styles.showGrid}>
                    {placeholders(8).map((i) => (
                        <div className={styles.showCard} key={i}>
                            <Skeleton className={styles.showImage} radius="md" />
                            <div className={styles.showText}>
                                <Skeleton height={16} mb={6} width="85%" />
                                <Skeleton height={12} width="55%" />
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};
